import { EGallerySection } from '../../types/redux/gallery';
import { TGallerySectionsConfig } from './types';

export const GALLERY_SECTIONS_CONFIG: TGallerySectionsConfig = {
  [EGallerySection.Layout]: {
    type: EGallerySection.Layout,
    id: 'flatplan',
    title: 'Планировка',
  },
  [EGallerySection.FloorPlan]: {
    type: EGallerySection.FloorPlan,
    id: 'floorplan',
    title: 'План этажа',
  },
  [EGallerySection.Tour]: {
    type: EGallerySection.Tour,
    id: '3dtour',
    title: '3D-тур по квартире',
  },
  [EGallerySection.JKGallery]: {
    type: EGallerySection.JKGallery,
    id: 'JKgallery',
    title: 'Галерея комплекса',
  },
  [EGallerySection.OffersPhotos]: {
    type: EGallerySection.OffersPhotos,
    id: 'offersPhotos',
    title: 'Фотографии из объявления',
  },
  [EGallerySection.Gallery]: {
    type: EGallerySection.Gallery,
    id: 'gallery',
    title: 'Галерея',
  },
};
